import { Component, OnInit, EventEmitter, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { DCInput } from "../dynamic.service";

@Component({
    selector: 'alert-dialog',
    template: `<dialog-window [title]="title" (close)="close()" >
                <span [innerText]="message"></span>
                <div dialog-footer class="handler-buttons">
                    <button tabindex="2" #buttonOk (click)="close()" class="blue-button">OK</button>
                </div>
              </dialog-window>`
})

export class AlertDialogComponent implements OnInit, OnDestroy, AfterViewInit, DCInput {
    /**
     * Заголовок диалогового окна
     */
    title = "Внимание!";
    /**
     * Выводимое сообщение
     */
    message = "Важное сообщение.";
    /**
     * Подписчик для удаления компоненты
     */
    destroyEmitter:EventEmitter<null> = new EventEmitter();
    @ViewChild("buttonOk", {static: true}) buttonOk:ElementRef;
    constructor() { }

    ngOnInit() { }
    ngOnDestroy(){
        this.destroyEmitter.complete();
    }
    ngAfterViewInit(){
        // Фокусируем кнопку, чтобы по enter закрывалось окно.
        (<HTMLButtonElement>this.buttonOk.nativeElement).focus();
    }
    /**
     * Закрывает диалоговое окно
     */
    close(){
        this.destroyEmitter.emit(null);
    }
}